export const initialState = {
  actionProcessing: false,
  usersList: {},
  newPassword: '',
};